import api from './api';

export type CompraAvulsaStatus = 'pendente' | 'paga' | 'recusada' | 'expirada' | 'estornada';

export interface ProdutoAvulso {
  slug: string;
  nome: string;
  valorCentavos: number;
  /** Livro customizado: monta o livro no Hero Book antes de pagar. */
  exigeLivroHeroBook: boolean;
}

export interface CompraAvulsa {
  compraId: string;
  status: CompraAvulsaStatus;
  metodo: 'cartao' | 'pix';
  produto: { slug: string; nome: string };
  valorCentavos: number;
  pix: { emv: string; qrCode: string | null; expiraEm: string | null } | null;
}

interface BaseCompra {
  produto: string;
  email: string;
  idempotencyKey: string;
  turnstileToken?: string;
  heroDraftId?: string;
  heroDraftKey?: string;
}

export interface CartaoCompra extends BaseCompra {
  nomeCartao: string;
  numero: string;
  cvv: string;
  mes: number;
  ano: number;
}

// A API responde no envelope { success, data } (TransformResponseInterceptor).
export const CompraAvulsaService = {
  async produto(slug: string): Promise<ProdutoAvulso> {
    const res = await api.get(`/compras-avulsas/produtos/${encodeURIComponent(slug)}`);
    return res.data.data;
  },

  async pagarComCartao(body: CartaoCompra): Promise<CompraAvulsa> {
    // Cobrança no cartão pode levar até 60s na AppMax.
    const res = await api.post('/compras-avulsas/cartao', body, { timeout: 70000 });
    return res.data.data;
  },

  async gerarPix(body: BaseCompra): Promise<CompraAvulsa> {
    const res = await api.post('/compras-avulsas/pix', body, { timeout: 30000 });
    return res.data.data;
  },

  async status(compraId: string): Promise<CompraAvulsa> {
    const res = await api.get(`/compras-avulsas/${compraId}`);
    return res.data.data;
  },
};
